/**
 * Three ways to work with the studio, with the rates on them.
 *
 * The prices come from RATES rather than the dictionaries, because the two
 * languages quote genuinely different numbers — a Mexican client is quoted a
 * Mexican rate, not a converted US one — and a number is not translation copy.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import { RATES } from '../lib/constants';
import styles from './Engagements.module.css';

export function Engagements() {
  const { t, locale } = useI18n();
  const rates = RATES[locale];
  const prices = [rates.project, rates.retainer, rates.embedded];

  return (
    <Section id="pricing" title={t.engagements.title} tone="paper">
      <div className={`grid ${styles.grid}`}>
        {t.engagements.items.map((item, index) => (
          <article key={item.name} className="cell">
            <p className={styles.tag}>{item.tag}</p>
            <h3 className={styles.name}>{item.name}</h3>
            <p className={styles.body}>{item.body}</p>
            <p className={styles.price}>{prices[index]}</p>
            <p className="meta">{item.terms}</p>
          </article>
        ))}
      </div>
    </Section>
  );
}
